export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const parseContentDispositionFilename = (
  header?: string | null
): string | null => {
  if (!header) return null;

  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const asciiMatch = header.match(/filename\*?=(?:UTF-8''|")?([^";]+)"?/i);
  if (!asciiMatch?.[1]) return null;

  const value = asciiMatch[1].trim();
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
